import { GET, GET_BLOB, POST, PUT, DELETE } from './apiController';

// ------------------------------------------------- Plans


export const getAllPlans = () => GET('/org/billing/plans');
export const getPlanById = (id) => GET(`/org/billing/plans/${id}`);
export const getCurrentPlan = () => GET('/org/billing/subscriptions/current');
export const createPlan = (data) => POST('/org/billing/admin/plans', data);
export const updatePlan = (id, data) => PUT(`/org/billing/admin/plans/${id}`, data);
export const deletePlan = (id) => DELETE(`/org/billing/admin/plans/${id}`);

// ------------------------------------------------- Subscriptions

export const getAllSubscriptions = (params) => GET('/org/billing/admin/subscriptions', params);
export const getSubscriptionById = (id) => GET(`/org/billing/admin/subscriptions/${id}`);
export const createSubscription = (data) => POST('/org/billing/admin/subscriptions', data);
export const updateSubscription = (id, data) => PUT(`/org/billing/admin/subscriptions/${id}`, data);
export const exportSubscriptions = (params) => GET_BLOB('/org/billing/admin/subscriptions/export', params);

// ------------------------------------------------- Transactions

export const createOrder = (data) => POST('/org/billing/transactions/create-order', data);
export const verifyPayment = (data) => POST('/org/billing/transactions/verify-payment', data);
export const cancelOrder = (data) => POST('/org/billing/transactions/cancel-order', data);
export const createCourseOrder = (data) => POST('/org/billing/transactions/create-course-order', data);
export const verifyCoursePayment = (data) => POST('/org/billing/transactions/verify-course-payment', data);
export const cancelCourseOrder = (data) => POST('/org/billing/transactions/cancel-course-order', data);
export const getUserTransactions = (params) => GET('/org/billing/user/transactions/history', params);
export const getAllTransactions = (params) => GET('/org/billing/admin/transactions', params);
export const getTransactionById = (id) => GET(`/org/billing/admin/transactions/${id}`);
export const exportTransactions = (params) => GET_BLOB('/org/billing/admin/transactions/export', params);

// ------------------------------------------------- Refunds

export const createRefund = (data) => POST('/org/billing/admin/refunds', data);
export const getUserRefunds = (params) => GET('/org/billing/user/refunds', params);
export const requestRefund = (data) => POST('/org/billing/user/refunds/request', data);
export const getAllRefunds = (params) => GET('/org/billing/admin/refunds', params);
export const getRefundById = (id) => GET(`/org/billing/admin/refunds/${id}`);
export const updateRefundStatus = (id, data) => PUT(`/org/billing/admin/refunds/${id}/status`, data);

// ------------------------------------------------- Coupons

export const createCoupon = (data) => POST('/org/billing/admin/coupons', data);
export const getAllCoupons = (params) => GET('/org/billing/admin/coupons', params);
export const getCouponById = (id) => GET(`/org/billing/admin/coupons/${id}`);
export const updateCoupon = (id, data) => PUT(`/org/billing/admin/coupons/${id}`, data);
export const deleteCoupon = (id) => DELETE(`/org/billing/admin/coupons/${id}`);
export const getCouponStats = (id) => GET(`/org/billing/admin/coupons/${id}/stats`);
export const validateCoupon = (data) => POST('/org/billing/coupons/validate', data);
export const applyCouponToTransaction = (data) => POST('/org/billing/coupons/apply', data);

// ------------------------------------------------- Wallet

export const getWalletBalance = () => GET('/org/billing/wallet/balance');
export const getWalletTransactions = (params) => GET('/org/billing/wallet/transactions', params);
export const getRewardStreak = () => GET('/org/billing/rewards/streak');
export const redeemRewardStreak = () => POST('/org/billing/rewards/streak/redeem');
export const getReferrals = () => GET('/org/billing/referrals');

// ------------------------------------------------- Course Purchase

export const checkCoursePurchase = (course_id) => GET('/org/billing/courses/check-purchase', { course_id });